import React, {useContext, useEffect} from 'react';
import {
	Badge,
	Paper, Slide,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Typography, useTheme, Zoom
} from "@mui/material";
import {blue, orange} from "@mui/material/colors";
import {addDays, capitalizeFirstLetter} from "../../../../../utils/GenericUtils";
import moment from "moment";
import {innerStyle} from "../../../../../styles/pages/home/MaterialYouBaseStyle";
import {endOfMonth, endOfWeek, isSameDay, isSameMonth, startOfMonth, startOfWeek} from "date-fns";
import itLocale from "date-fns/locale/it";
import withStyles from '@mui/styles/withStyles';
import localization from 'moment/locale/it';
import {AppContext} from "../../../../../App";
import {getEventiBetween} from "../../../../../services/AppServices";

export const CalendarioPaper = () => {
	const classes = innerStyle();
	let theme = useTheme();
	const appContext = useContext(AppContext);

	useEffect(() => {
		const monthStart = startOfMonth(new Date());
		const monthEnd = endOfMonth(monthStart);
		getEventiBetween(monthStart, monthEnd, appContext.dispatch)
	}, [appContext.dispatch])

	return (
		<React.Fragment>
			<Slide direction={"up"} in={true} mountOnEnter unmountOnExit style={{transitionDelay: "200ms"}}>
				<Paper className={classes.paper} component={"section"}>
					<Typography variant={"h6"} style={{paddingLeft: 6}}>
						<b>Calendario</b>
					</Typography>
					<Typography variant={"subtitle2"} color={"textSecondary"} style={{paddingLeft: 6}}>
						Visualizza e gestisci le giornate
					</Typography>

					<Paper style={{
						borderRadius: 20,
						marginTop: 8,
						margin: 4,
					}}
					       elevation={0}>
						<Typography style={{
							padding: 4,
							paddingTop: 12,
							borderRadius: "24px 24px 0 0",
							color: theme.palette.mode === "light" ? blue[700] : blue[100],
						}} align={"center"}>
							<b>{capitalizeFirstLetter(moment(new Date()).locale("it", localization).format("MMMM YYYY"))}</b>
						</Typography>

						<TableContainer style={{paddingBottom: 8}}>
							<Table size={"small"}>
								<TableHead>
									<TableRow>
										{
											["lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato", "domenica"].map((item) => {
												return (
													<TableCell style={{
														border: "none",
													}} align={"center"}
													           key={item}>
														<Typography color={"textSecondary"} style={{
															fontSize: 14,
															textTransform: "capitalize"
														}}
														            variant={"body2"}>
															{item}
														</Typography>
													</TableCell>
												)
											})
										}
									</TableRow>
								</TableHead>
								<TableBody>
									{daysCell(theme)}
								</TableBody>
							</Table>
						</TableContainer>
					</Paper>

				</Paper>
			</Slide>
		</React.Fragment>
	);
};

function daysCell(theme) {
	const classes = innerStyle();
	const monthStart = startOfMonth(new Date());
	const monthEnd = endOfMonth(monthStart);
	const startDate = startOfWeek(monthStart, {
		locale: itLocale
	});
	const endDate = endOfWeek(monthEnd, {
		locale: itLocale
	});

	const rows = [];
	let days = [];
	let day = startDate;
	day.setHours(0);
	day.setMinutes(0);
	day.setSeconds(0);
	day.setMilliseconds(0);
	let formattedDate = "";
	let key = 1234;


	while (day <= endDate) {
		for (let i = 0; i < 7; i++) {
			formattedDate = moment(day).format("D");

			days.push(
				<Zoom key={day.toLocaleDateString()} in={true} style={{
					transitionDelay: ((i + 3) + "00ms")
				}}>
					<TableCell style={{
						border: "none",
						height: 55,
					}} align={"center"}>
						{
							isSameDay(day, new Date()) ?
								<Typography
									component={"div"}
									style={{
										backgroundColor: theme.palette.mode === "light" ? orange[100] : orange[900],
										borderRadius: 20,
										color: theme.palette.mode === "light" ? orange[900] : orange[100],
										height: "100%",
										display: "flex",
										alignItems: "center",
										alignContent: "center",
										justifyContent: "center",
										position: "relative",
										width: 55,
									}}>
									<b style={{minWidth: 30, fontSize: 20}}>{formattedDate}</b>
								</Typography> :
								<Typography className={classes.dayCell}
								            style={!isSameMonth(day, monthStart) ? {
									            backgroundColor: theme.palette.background.paper,
									            color: theme.palette.mode === "light" ? blue[100] : blue[700]
								            } : {}}
								            color={!isSameMonth(day, monthStart) ? "textSecondary" : "textPrimary"}>
									{
										!isSameMonth(day, monthStart) ? formattedDate :
											<StyledBadgeAmber badgeContent={Math.floor(Math.random() * (5 + 1))}
											                  color={"primary"}
											                  showZero={false}>
												<b style={{minWidth: 30, fontSize: 20}}>{formattedDate}</b>
											</StyledBadgeAmber>
									}
								</Typography>
						}
					</TableCell>
				</Zoom>
			);
			day = addDays(day, 1)
		}
		rows.push(
			<TableRow key={key}>
				{days}
			</TableRow>
		)
		key += 1;
		days = [];
	}
	return (
		<React.Fragment>
			{rows}
		</React.Fragment>
	)
}

const StyledBadgeAmber = withStyles((theme) => ({
	badge: {
		right: -5,
		top: -5,
		backgroundColor: theme.palette.mode === "light" ? blue[500] : blue[50],
		color: theme.palette.mode === "light" ? blue[50] : blue[900]
	},
}))(Badge);
